import { AlertTriangle, ClipboardCopy, Check } from "lucide-react";
import { useState } from "react";

const TileSanction = ({ data = {}, t }) => {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const toStr = (v) =>
    typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";

  const sanctionsTitle = toStr(data.sanctions_title);
  const sanctionsSummary = toStr(data.sanctions_summary);
  const companyName = toStr(data.company_name);
  const sources = Array.isArray(data.sources) ? data.sources : [];

  if (!sanctionsTitle) return null;

  const parseSource = (s) => toStr(s).split(" ")[0];

  const handleCopy = (s, i) => {
    navigator.clipboard.writeText(parseSource(s)).then(() => {
      setCopiedIndex(i);
      setTimeout(() => setCopiedIndex(null), 1500);
    });
  };

  const divider = { paddingTop: 12, borderTop: `1px solid ${t.divider}` };

  const iconBox = {
    width: 30,
    height: 30,
    borderRadius: 8,
    background: t.iconBg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };

  return (
    <div style={{ minWidth: 0, overflow: "hidden" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={iconBox}>
            <AlertTriangle
              size={14}
              style={{ color: t.textPrimary }}
              strokeWidth={1.5}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              minWidth: 0,
            }}
          >
            <p
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: t.textPrimary,
                margin: 0,
                lineHeight: 1.4,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {sanctionsTitle}
            </p>
            {companyName && (
              <p
                style={{
                  fontSize: 12,
                  color: t.textPrimary,
                  opacity: 0.7,
                  margin: 0,
                }}
              >
                {companyName}
              </p>
            )}
          </div>
        </div>

        {/* Summary */}
        {sanctionsSummary && (
          <p
            style={{
              ...divider,
              fontSize: 13,
              color: t.textPrimary,
              opacity: 0.8,
              margin: 0,
              lineHeight: 1.6,
              display: "-webkit-box",
              WebkitLineClamp: 5,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {sanctionsSummary}
          </p>
        )}

        {/* Sources */}
        {sources.length > 0 && (
          <div
            style={{
              ...divider,
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <p
              style={{
                fontSize: 10,
                fontWeight: 600,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: t.textPrimary,
                opacity: 0.35,
                margin: 0,
              }}
            >
              Sources
            </p>
            {sources.map((s, i) => {
              const url = parseSource(s);
              const copied = copiedIndex === i;
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: 0,
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      color: t.textPrimary,
                      opacity: 0.7,
                      margin: 0,
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      minWidth: 0,
                    }}
                  >
                    {url}
                  </p>
                  <button
                    onClick={() => handleCopy(s, i)}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 4,
                      cursor: "pointer",
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: t.textPrimary,
                      opacity: copied ? 1 : 0.4,
                      transition: "opacity 0.15s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.opacity = copied ? 1 : 0.4)
                    }
                  >
                    {copied ? (
                      <Check size={13} strokeWidth={2} />
                    ) : (
                      <ClipboardCopy size={13} strokeWidth={1.5} />
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileSanction;
